import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var userDataExon = localStorage.getItem("userDataExon") ? JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon")))) : "";
var serviceName = "controller";
var controllerService = {
    imageUrlBuyuk: WsProvider.resim+"/"+userDataExon["firmaKodu"]+"/buyuk/",
    imageUrlOrta: WsProvider.resim+"/"+userDataExon["firmaKodu"]+"/orta/",
    imageUrlKucuk: WsProvider.resim+"/"+userDataExon["firmaKodu"]+"/kucuk/",
    resimYukle(modul,name, base) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                modul: modul,
                name: name,
                base: base,
                methodName: "resimyukle",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    sunucuResim(modul) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                modul: modul,
                methodName: "sunucuResim",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    belgeYukle(modul,name, base) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                modul: modul,
                name: name,
                base: base,
                methodName: "belgeyukle",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    sunucuBelge(modul) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                modul: modul,
                methodName: "sunucuBelge",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    }
};
export default controllerService



